import React from 'react'
import Layout from '../../Layout/Layout'
import 'react-quill/dist/quill.snow.css';
import AiQuillEditor from '../../Global/AiQuillEditor';
import { ArrowUturnLeftIcon, DocumentTextIcon, CheckIcon, DocumentDuplicateIcon, FolderArrowDownIcon } from '@heroicons/react/24/outline';
import { Menu, MenuButton, MenuItem, MenuItems, Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { CodeBracketIcon, XCircleIcon } from '@heroicons/react/24/solid';
import { useState, useEffect } from 'react'
import HotDealsIcon from '../../../lottie/process';
import Lottie from 'react-lottie-player';

function ArticleGenerator() {
    const [open, setOpen] = useState(true)
    useEffect(() => {
        const timer = setTimeout(() => {
          setOpen(false);
        }, 11000); // 5000 milliseconds = 5 seconds
    
        // Cleanup function to clear the timer if the component unmounts
        return () => clearTimeout(timer);
      }, []);
    // counter
    const [count, setCount] = useState(1);

    useEffect(() => {
        const intervalId = setInterval(() => {
        setCount((prevCount) => {
            if (prevCount < 100) {
            return prevCount + 1;
            } else {
            clearInterval(intervalId); // Stop the counter at 100
            return prevCount;
            }
        });
        }, 100); // Update every 100 milliseconds (adjust as needed)

        // Cleanup function to clear the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, []);
    return (
        <Layout>
            <Dialog open={open} onClose={setOpen} className="relative z-10">
                <DialogBackdrop transition className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in" />
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel transition className="relative transform overflow-hidden rounded-lg bg-white px-4 py-6 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95" >
                            <div>
                                <div className="mx-auto flex size-36 items-center justify-center0">
                                    <Lottie animationData={HotDealsIcon} play loop />
                                </div>
                                <div className="mt-1 text-center sm:mt-5">
                                    <DialogTitle as="h3" className="text-2xl font-semibold text-gray-900"> Writing the article {`(${count}%)`} </DialogTitle>
                                    <div className="mt-2 mb-4">
                                        <p className="text-sm text-gray-500 mb-1"> Please wait, this can take a few minutes.</p>
                                        <p className="text-sm text-gray-500">
                                            Taking too long? 
                                            <button type="button" onClick={() => setOpen(false)} className="rounded px-2 py-1 text-xs font-semibold text-red-600" >
                                                Close this popup
                                            </button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
            <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
                <div className='border-b text-gray-50 bg-white rounded-3xl shadow-lg overflow-hidden'>
                    <div className="px-6 lg:px-8 py-4 lg:py-6 flex items-center md:justify-between border-b border-gray-200">
                        <div className="min-w-0 flex-1">
                            <h2 className="text-xl/7 lg:text-lg font-bold text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
                            <a
                                href='/ai-article/add-article'
                                className="inline-flex items-center gap-x-2  px-3.5 py-2.5 text-sm font-semibold text-slate-400 hover:text-slate-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 "
                            >
                                <ArrowUturnLeftIcon aria-hidden="true" className="-ml-0.5 size-5" />
                                Go back
                            </a>
                            </h2>
                        </div>
                        <div className="mt-4 flex flex-shrink-0 md:ml-4 md:mt-0">
                            
                            <Menu as="div" className="relative inline-block text-left me-2">
                                <div>
                                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                                        <DocumentDuplicateIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                                        Copy Content
                                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                                    </MenuButton>
                                </div>

                                <MenuItems transition className="absolute right-0 z-10 mt-2 w-36 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in" >
                                    <div className="py-1">
                                        <MenuItem>
                                            <a href="#" className="flex items-center px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none" >
                                                <CodeBracketIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400 me-2" />
                                                HTML Code
                                            </a>
                                        </MenuItem>
                                        <MenuItem>
                                            <a href="#" className="flex items-center px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none" >
                                                <DocumentTextIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400 me-2" />
                                                Plain Text
                                            </a>
                                        </MenuItem>
                                    </div>
                                </MenuItems>
                            </Menu>
                            <button
                                type="button"
                                className="inline-flex items-center rounded-md bg-red-600 px-4 lg:px-5 py-2 text-xs lg:text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                            >
                                <FolderArrowDownIcon aria-hidden="true" className="-mr-1 size-5 me-2" />
                                Save Changes
                            </button>
                        </div>
                    </div>
                    <div className='bg-slate-200 sm:flex sm:gap-px sm:divide-y-0 text-gray-600'>
                        <div className="sm:w-2/3 bg-white text-gray-500">
                            <div className="grid grid-cols-1 gap-x-6 gap-y-8">
                                <AiQuillEditor placeholder='Enter personality here...' />
                            </div>
                        </div>
                        <div className="sm:w-1/3 relative bg-white">
                            <div className='grid grid-cols-2 divide-y'>
                                <div className='flex flex-col items-center py-5'>
                                    <p className='text-xs font-semibold text-slate-400'>Words</p>
                                    <p className='font-bold text-2xl'>823</p>
                                </div>
                                <div className='flex flex-col items-center py-5'>
                                    <p className='text-xs font-semibold text-slate-400'>Headings</p>
                                    <p className='font-bold text-2xl'>7</p>
                                </div>
                                <div className='flex flex-col items-center py-5'>
                                    <p className='text-xs font-semibold text-slate-400'>Paragraphs</p>
                                    <p className='font-bold text-2xl'>6</p>
                                </div>
                                <div className='flex flex-col items-center py-5'>
                                    <p className='text-xs font-semibold text-slate-400'>Links</p>
                                    <p className='font-bold text-2xl'>1</p>
                                </div>
                            </div>
                            <div class="px-6 lg:px-8 py-4 lg:py-6 flex items-center md:justify-between border-t border-gray-200">
                                <div class="min-w-0 flex-1"><h2 class="text-xl/7 lg:text-lg font-bold text-gray-900 sm:truncate sm:tracking-tight">Content Analysis</h2></div>
                            </div>
                            <div class="px-6 lg:px-8">
                                <ul class="list-none gap-2 grid grid-cols-1">
                                    <li className='text-sm flex items-center'><XCircleIcon aria-hidden="true" className="-mr-1 size-5 text-red-400 me-2" /> Content is over 800 words long.</li>
                                    <li className='text-sm flex items-center'><XCircleIcon aria-hidden="true" className="-mr-1 size-5 text-red-400 me-2" /> Main heading contains keyword.</li>
                                    <li className='text-sm flex items-center'><XCircleIcon aria-hidden="true" className="-mr-1 size-5 text-red-400 me-2" /> Subheadings contain keyword.</li>
                                    <li className='text-sm flex items-center'><XCircleIcon aria-hidden="true" className="-mr-1 size-5 text-red-400 me-2" /> Keyword found in the content.</li>
                                    <li className='text-sm flex items-center'><XCircleIcon aria-hidden="true" className="-mr-1 size-5 text-red-400 me-2" /> Keyword is in the first 2 paragraphs.</li>
                                    <li className='text-sm flex items-center'><XCircleIcon aria-hidden="true" className="-mr-1 size-5 text-red-400 me-2" /> Keyword density is 0.</li>
                                    <li className='text-sm flex items-center'><XCircleIcon aria-hidden="true" className="-mr-1 size-5 text-red-400 me-2" /> Title contains a number.</li>
                                    <li className='text-sm flex items-center'><XCircleIcon aria-hidden="true" className="-mr-1 size-5 text-red-400 me-2" /> Focus on less than 3 keywords.</li>
                                    <li className='text-sm flex items-center'><XCircleIcon aria-hidden="true" className="-mr-1 size-5 text-red-400 me-2" /> Use a minimum of 3 paragraphs.</li>
                                    <li className='text-sm flex items-center'><XCircleIcon aria-hidden="true" className="-mr-1 size-5 text-red-400 me-2" /> Use short paragraphs.</li>
                                    <li className='text-sm flex items-center'><XCircleIcon aria-hidden="true" className="-mr-1 size-5 text-red-400 me-2" /> Use a minimum of 4 subheadings.</li>
                                    <li className='text-sm flex items-center'><XCircleIcon aria-hidden="true" className="-mr-1 size-5 text-red-400 me-2" /> Use a minimum of 5 links.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default ArticleGenerator
